import { combineReducers } from "redux";
import questions from "./questions";
import student from "./student";
import exam from "./exam";

export default combineReducers({ questions, student, exam });
